import { combineReducers } from 'redux'
import network from './network'
import comps from './comps'

export default combineReducers({ network, comps })
